import { apiClient } from 'axios-client';
import React, { FunctionComponent, useCallback } from 'react';
import { ProStatsCallsContainer } from './pro-stats-calls-container';

type Props = {
  startDate: Date;
  endDate: Date;
  proViewId: number;
};

export type CallCountByMonth = {
  month: Date;
  count: number;
  uniqueCount: number;
}[];

export const ProStatsCallsRepository: FunctionComponent<Props> = ({
  startDate,
  endDate,
  proViewId,
}) => {
  const fetchCalls = useCallback(
    async () =>
      await apiClient
        .post<CallCountByMonth>(`/event/pro-calls-by-month`, {
          proViewId,
          after: startDate,
          before: endDate,
        })
        .then((response) => {
          return response.data;
        }),
    [startDate, endDate],
  );

  return (
    <ProStatsCallsContainer
      startDate={startDate}
      endDate={endDate}
      fetchCalls={fetchCalls}
    />
  );
};
